import { Injectable } from '@angular/core';
import { ToastMessage } from '../model/toast-message';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastrService: ToastrService) {}

  clear(): void {
    this.toastrService.clear();
  }

  error(toastMessage: ToastMessage): void {
    this.toastrService.error(toastMessage.message, toastMessage.title, {
      timeOut: 30000,
    });
  }

  success(toastMessage: ToastMessage): void {
    this.toastrService.success(toastMessage.message, toastMessage.title);
  }
}
